import { AbstractDialog } from "../../../../../ui/dialogs/AbstractDialog";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteCareDialog = (props: Props) => {
  const actionButtons = (
    <Button
      color={"error"}
      endIcon={<DeleteIcon />}
      onClick={() => {
        props.onConfirm();
        props.onClose();
      }}
    >
      Smazat
    </Button>
  );

  return (
    <AbstractDialog open={props.open} onClose={props.onClose} title={"Smazat šablonu"} buttons={actionButtons}>
      Opravdu si přejete šablonu smazat?
    </AbstractDialog>
  );
};
